import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

import { ChangePasswordComponent } from "./change-password.component";

const routesChangePassword: Routes = [
  {
    path: "",
    component: ChangePasswordComponent,
    canActivate: [LoginGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesChangePassword)],
  exports: [RouterModule],
})
export class ChangePasswordRoutingModule {}
